const roles = (state = {}, action) => {
    switch (action.type) {
        case "STORE_ROLES":
            return action.payload;
        default:
            return state;
    }
};

export default roles;
